import TagsInput from './TagsInput';
export default TagsInput;
